export default __webpack_public_path__ + "static/media/2154.b0ae1481.png";